import { Col } from "react-bootstrap";

export const ProjectCard = ({ title, description, imgUrl, url, dbName }) => {
  const handleClick = (e) => {
    if (!url) return;
    fetch("/api/statistics", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ visitorId, feature: dbName }),
                });
              
    e.preventDefault();
    window.open(url, "_blank");
  };
  const visitorId = localStorage.getItem("visitorId");

  return (
    <Col size={12} sm={6} md={4} 
      onClick={url ? handleClick : undefined}
      style={{ cursor: url ? "pointer" : "default" }}>
      <div className="proj-imgbx" style={{ 
        width: "100%", 
        height: "250px",
        overflow: "hidden",
        borderRadius: "12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#111",}}
      >
        <img src={imgUrl} alt={title}
        style={{
            width: "100%",
            height: "100%",
            objectFit: "contain"
          }}
        />
        <div className="proj-txtx">
          <h4>{title}</h4>
          <span>{description}</span>
        </div>
      </div>
    </Col>
  )
}